/* ============================================================
   ilo sitelen — glyph data
   ------------------------------------------------------------
   Flat pictogram data for every drawable entity word. Pure data,
   no React — SceneRenderer turns these into SVG elements.

   Canvas: 100x100, feet/bottom near y=88 (suno and mun float).
   Shape: { t: "path"|"circle"|"ellipse"|"rect"|"line", ...attrs,
            f?: "body"|"detail"|"none", s?: "detail"|"none", w?: n }
   - f:"body"   → recolorable silhouette (takes the entity's color)
   - f:"detail" → fixed dark accents (eyes, doors, text lines)
   - rect stroke width uses w2 (w is the rect's width)

   Pronouns (mi/sina/ona) reuse the jan glyph with a label — see
   SceneRenderer.
   ============================================================ */

export const GLYPHS = {
  // ---- creatures ----
  jan: { shapes: [
    { t: "ellipse", cx: 27, cy: 54, rx: 6, ry: 15, f: "body" },
    { t: "ellipse", cx: 73, cy: 54, rx: 6, ry: 15, f: "body" },
    { t: "rect", x: 40, y: 72, w: 8, h: 16, rx: 4, f: "body" },
    { t: "rect", x: 52, y: 72, w: 8, h: 16, rx: 4, f: "body" },
    { t: "rect", x: 33, y: 38, w: 34, h: 38, rx: 14, f: "body" },
    { t: "circle", cx: 50, cy: 23, r: 14, f: "body" },
    { t: "circle", cx: 45, cy: 22, r: 2, f: "detail" },
    { t: "circle", cx: 55, cy: 22, r: 2, f: "detail" },
    { t: "path", d: "M45,28 Q50,32 55,28", f: "none", s: "detail", w: 2 },
  ] },
  soweli: { shapes: [
    { t: "ellipse", cx: 50, cy: 60, rx: 25, ry: 20, f: "body" },
    { t: "rect", x: 32, y: 74, w: 10, h: 14, rx: 5, f: "body" },
    { t: "rect", x: 58, y: 74, w: 10, h: 14, rx: 5, f: "body" },
    { t: "circle", cx: 37, cy: 17, r: 7, f: "body" },
    { t: "circle", cx: 63, cy: 17, r: 7, f: "body" },
    { t: "circle", cx: 50, cy: 30, r: 16, f: "body" },
    { t: "circle", cx: 44, cy: 29, r: 2.3, f: "detail" },
    { t: "circle", cx: 56, cy: 29, r: 2.3, f: "detail" },
    { t: "path", d: "M45,36 Q50,40 55,36", f: "none", s: "detail", w: 2 },
  ] },
  waso: { shapes: [
    { t: "path", d: "M20,78 Q8,72 10,64 Q16,70 26,76 Z", f: "body" },
    { t: "ellipse", cx: 52, cy: 60, rx: 19, ry: 21, f: "body" },
    { t: "circle", cx: 50, cy: 33, r: 13, f: "body" },
    { t: "path", d: "M58,45 Q75,50 68,68 Q58,66 55,55 Z", f: "body", s: "detail", w: 1.5 },
    { t: "path", d: "M62,32 L74,35 L62,40 Z", f: "detail" },
    { t: "circle", cx: 54, cy: 30, r: 2, f: "detail" },
    { t: "line", x1: 45, y1: 80, x2: 45, y2: 88, s: "detail", w: 2 },
    { t: "line", x1: 57, y1: 80, x2: 57, y2: 88, s: "detail", w: 2 },
  ] },
  kala: { shapes: [
    { t: "path", d: "M25,55 L8,40 L8,70 Z", f: "body" },
    { t: "ellipse", cx: 55, cy: 55, rx: 24, ry: 18, f: "body" },
    { t: "path", d: "M50,38 L58,22 L64,40 Z", f: "body" },
    { t: "path", d: "M50,70 L46,88 L60,72 Z", f: "body" },
    { t: "circle", cx: 68, cy: 50, r: 2.5, f: "detail" },
    { t: "path", d: "M76,55 Q80,57 76,60", f: "none", s: "detail", w: 1.5 },
    { t: "path", d: "M64,45 Q62,55 64,65", f: "none", s: "detail", w: 1.5 },
  ] },
  akesi: { shapes: [
    { t: "path", d: "M20,78 Q8,72 10,64 Q16,70 26,76 Z", f: "body" },
    { t: "ellipse", cx: 50, cy: 74, rx: 25, ry: 12, f: "body" },
    { t: "rect", x: 28, y: 80, w: 7, h: 8, rx: 3, f: "body" },
    { t: "rect", x: 40, y: 80, w: 7, h: 8, rx: 3, f: "body" },
    { t: "rect", x: 54, y: 80, w: 7, h: 8, rx: 3, f: "body" },
    { t: "rect", x: 66, y: 80, w: 7, h: 8, rx: 3, f: "body" },
    { t: "path", d: "M70,66 Q90,68 92,74 Q90,81 70,82 Z", f: "body" },
    { t: "circle", cx: 82, cy: 71, r: 2.2, f: "detail" },
    { t: "path", d: "M35,63 L38,58 L41,63 L45,61 L48,56 L51,61 L55,63", f: "none", s: "detail", w: 1.8 },
  ] },
  pipi: { shapes: [
    { t: "ellipse", cx: 50, cy: 58, rx: 20, ry: 16, f: "body" },
    { t: "circle", cx: 50, cy: 33, r: 11, f: "body" },
    { t: "path", d: "M44,25 Q39,13 34,10 M56,25 Q61,13 66,10", f: "none", s: "detail", w: 1.8 },
    { t: "path", d: "M32,52 L14,63 M31,60 L12,74 M33,68 L15,87", f: "none", s: "detail", w: 1.8 },
    { t: "path", d: "M68,52 L86,63 M69,60 L88,74 M67,68 L85,87", f: "none", s: "detail", w: 1.8 },
    { t: "path", d: "M50,44 L50,72", f: "none", s: "detail", w: 1.8 },
    { t: "circle", cx: 42, cy: 56, r: 2.5, f: "detail" },
    { t: "circle", cx: 58, cy: 56, r: 2.5, f: "detail" },
    { t: "circle", cx: 45, cy: 31, r: 1.8, f: "detail" },
    { t: "circle", cx: 55, cy: 31, r: 1.8, f: "detail" },
  ] },

  // ---- food & nature ----
  kili: { shapes: [
    { t: "circle", cx: 50, cy: 68, r: 22, f: "body" },
    { t: "ellipse", cx: 64, cy: 44, rx: 4, ry: 9, f: "body" },
    { t: "circle", cx: 50, cy: 70, r: 2, f: "detail" },
  ] },
  pan: { shapes: [
    { t: "rect", x: 28, y: 55, w: 44, h: 35, rx: 10, f: "body" },
    { t: "line", x1: 38, y1: 58, x2: 38, y2: 88, s: "detail", w: 2 },
    { t: "line", x1: 50, y1: 58, x2: 50, y2: 88, s: "detail", w: 2 },
    { t: "line", x1: 62, y1: 58, x2: 62, y2: 88, s: "detail", w: 2 },
  ] },
  kasi: { shapes: [
    { t: "path", d: "M 42 80 Q 35 65 40 50 Q 42 40 50 35 Q 58 40 60 50 Q 65 65 58 80 Z", f: "body" },
    { t: "line", x1: 42, y1: 50, x2: 38, y2: 42, s: "detail", w: 1.5 },
    { t: "line", x1: 58, y1: 50, x2: 62, y2: 42, s: "detail", w: 1.5 },
  ] },
  telo: { shapes: [
    { t: "path", d: "M 50 44 Q 38 58 38 70 Q 38 84 50 88 Q 62 84 62 70 Q 62 58 50 44 Z", f: "body" },
    { t: "path", d: "M 44 72 Q 43 66 46 61", f: "none", s: "detail", w: 2 },
    { t: "path", d: "M 30 88 Q 40 84 50 88 Q 60 92 70 88", f: "none", s: "detail", w: 2 },
  ] },
  suno: { shapes: [
    { t: "circle", cx: 50, cy: 50, r: 15, f: "body" },
    { t: "line", x1: 50, y1: 25, x2: 50, y2: 10, s: "detail", w: 3 },
    { t: "line", x1: 75, y1: 50, x2: 90, y2: 50, s: "detail", w: 3 },
    { t: "line", x1: 50, y1: 75, x2: 50, y2: 90, s: "detail", w: 3 },
    { t: "line", x1: 25, y1: 50, x2: 10, y2: 50, s: "detail", w: 3 },
    { t: "line", x1: 68, y1: 32, x2: 78, y2: 22, s: "detail", w: 3 },
    { t: "line", x1: 68, y1: 68, x2: 78, y2: 78, s: "detail", w: 3 },
    { t: "line", x1: 32, y1: 68, x2: 22, y2: 78, s: "detail", w: 3 },
    { t: "line", x1: 32, y1: 32, x2: 22, y2: 22, s: "detail", w: 3 },
  ] },
  mun: { shapes: [
    { t: "path", d: "M 42 35 Q 38 42 38 50 Q 38 58 42 65 Q 55 58 55 50 Q 55 42 42 35 Z", f: "body" },
  ] },
  ma: { shapes: [
    { t: "path", d: "M 20 80 Q 30 60 50 50 Q 70 60 80 80 Z", f: "body" },
    { t: "line", x1: 15, y1: 88, x2: 85, y2: 88, s: "detail", w: 2 },
  ] },
  seli: { shapes: [
    { t: "path", d: "M 50 88 Q 42 75 44 55 Q 43 40 50 28 Q 57 40 56 55 Q 58 75 50 88 Z", f: "body" },
    { t: "path", d: "M 50 75 Q 47 65 48 55 Q 50 48 50 40", f: "none", s: "detail", w: 2 },
  ] },

  // ---- things & structures ----
  tomo: { shapes: [
    { t: "path", d: "M 35 65 L 50 45 L 65 65 Z", f: "body" },
    { t: "rect", x: 35, y: 65, w: 30, h: 20, f: "body" },
    { t: "rect", x: 46, y: 72, w: 8, h: 13, f: "detail" },
    { t: "circle", cx: 53, cy: 78, r: 1, f: "detail" },
  ] },
  poki: { shapes: [
    { t: "rect", x: 32, y: 50, w: 36, h: 30, rx: 2, f: "body" },
    { t: "path", d: "M 32 50 L 28 48 L 28 75 L 32 80 Z", f: "detail" },
    { t: "path", d: "M 68 50 L 72 48 L 72 75 L 68 80 Z", f: "detail" },
  ] },
  lipu: { shapes: [
    { t: "rect", x: 38, y: 40, w: 24, h: 45, rx: 2, f: "body" },
    { t: "line", x1: 42, y1: 50, x2: 58, y2: 50, s: "detail", w: 1 },
    { t: "line", x1: 42, y1: 58, x2: 58, y2: 58, s: "detail", w: 1 },
    { t: "line", x1: 42, y1: 66, x2: 58, y2: 66, s: "detail", w: 1 },
    { t: "line", x1: 42, y1: 74, x2: 58, y2: 74, s: "detail", w: 1 },
  ] },
  ilo: { shapes: [
    { t: "rect", x: 38, y: 60, w: 6, h: 28, rx: 3, f: "body" },
    { t: "circle", cx: 62, cy: 62, r: 12, f: "body" },
    { t: "path", d: "M 58 62 Q 62 56 66 62", f: "none", s: "detail", w: 1.5 },
  ] },
  supa: { shapes: [
    { t: "rect", x: 30, y: 55, w: 40, h: 7, rx: 2, f: "body" },
    { t: "rect", x: 35, y: 62, w: 5, h: 26, f: "body" },
    { t: "rect", x: 60, y: 62, w: 5, h: 26, f: "body" },
    { t: "rect", x: 42, y: 62, w: 3, h: 26, f: "detail" },
    { t: "rect", x: 55, y: 62, w: 3, h: 26, f: "detail" },
  ] },
  len: { shapes: [
    { t: "path", d: "M 32 50 L 35 75 Q 50 85 65 75 L 68 50 Q 60 60 50 63 Q 40 60 32 50 Z", f: "body" },
    { t: "line", x1: 42, y1: 55, x2: 40, y2: 75, s: "detail", w: 1.5 },
    { t: "line", x1: 58, y1: 55, x2: 60, y2: 75, s: "detail", w: 1.5 },
  ] },
  mani: { shapes: [
    { t: "circle", cx: 50, cy: 70, r: 18, f: "body" },
    { t: "circle", cx: 50, cy: 70, r: 10, f: "detail" },
  ] },
  kiwen: { shapes: [
    { t: "path", d: "M 24 88 L 20 64 L 36 46 L 62 42 L 80 60 L 78 88 Z", f: "body" },
    { t: "line", x1: 36, y1: 46, x2: 44, y2: 88, s: "detail", w: 2 },
    { t: "line", x1: 62, y1: 42, x2: 52, y2: 64, s: "detail", w: 2 },
    { t: "line", x1: 52, y1: 64, x2: 44, y2: 88, s: "detail", w: 2 },
  ] },
  palisa: { shapes: [
    { t: "path", d: "M 28 86 L 68 28 L 73 30 L 33 88 Z", f: "body" },
  ] },
  sike: { shapes: [
    { t: "circle", cx: 50, cy: 66, r: 22, f: "body" },
    { t: "path", d: "M 29 60 Q 50 76 71 60", f: "none", s: "detail", w: 2 },
    { t: "path", d: "M 33 78 Q 50 88 67 78", f: "none", s: "detail", w: 2 },
  ] },
};
